(() => {
  const buttonSelector = '.bndlr-add-to-cart';

  const getPropertyName = (name) => {
    const match = name.match(/^properties\[(.+)]$/);
    return match ? match[1] : null;
  };

  const getProperties = (product, bundle, bundleId) => {
    const properties = {};

    product.querySelectorAll('[name^="properties["]').forEach((field) => {
      const name = getPropertyName(field.name);

      if (name && (!field.matches('[type="checkbox"], [type="radio"]') || field.checked)) {
        properties[name] = field.value;
      }
    });

    bundle.querySelectorAll('.sealsubs-target-element-bundle [name^="properties["]').forEach((field) => {
      const name = getPropertyName(field.name);

      if (name && (!field.matches('[type="checkbox"], [type="radio"]') || field.checked)) {
        properties[name] = field.value;
      }
    });

    if (bundleId) properties._bundler_id = bundleId;

    return properties;
  };

  const showError = (container, message) => {
    let warning = container.querySelector('.bndlr-cart-redirect-warning');

    if (!warning) {
      warning = document.createElement('div');
      warning.className = 'bndlr-warning bndlr-cart-redirect-warning';
      warning.setAttribute('role', 'alert');
      container.querySelector('.bndlr-products-container')?.append(warning);
    }

    warning.textContent = message;
  };

  const getMissingRequiredOption = (container) => {
    for (const options of container.querySelectorAll('[data-bundle-frontend-options]')) {
      const requiredFields = Array.from(
        options.querySelectorAll('[data-frontend-variant-input][required]'),
      );
      const missingField = requiredFields.find((field) => {
        if (field.type !== 'radio') return !field.value;

        return !requiredFields.some(
          (candidate) => candidate.type === 'radio' && candidate.name === field.name && candidate.checked,
        );
      });

      if (missingField) return missingField;
    }

    return null;
  };

  const addBundleToCart = async (button) => {
    if (button.dataset.active === 'false' || button.dataset.cartRedirectBusy === 'true') return;

    const container = button.closest('.bndlr-container');
    const bundle = button.closest('[data-bundle]');

    if (!container || !bundle) return;

    const missingRequiredOption = getMissingRequiredOption(container);
    if (missingRequiredOption) {
      missingRequiredOption.closest('[data-bundle-frontend-options]')?.classList.add('is-invalid');
      showError(container, 'Please select all product options before adding this bundle to the cart.');
      missingRequiredOption.focus();
      return;
    }

    container.querySelector('.bndlr-cart-redirect-warning')?.remove();

    const bundleId = bundle.dataset.bundle;
    const bundleQuantity = Math.max(
      1,
      Number.parseInt(container.querySelector('.bndlr-add-to-cart-quantity-input')?.value, 10) || 1,
    );

    const items = Array.from(container.querySelectorAll('.bndlr-product')).map((product) => {
      const variantId = product.querySelector('select.bndlr-select-variant[name="variant_id"]')?.value;
      const quantity = Math.max(1, Number.parseInt(product.dataset.quantity, 10) || 1) * bundleQuantity;
      const properties = getProperties(product, bundle, bundleId);
      const sellingPlan = product.querySelector('[name="selling_plan"]')?.value;
      const item = { id: variantId, quantity, properties };

      if (sellingPlan) item.selling_plan = sellingPlan;

      return item;
    });

    if (!items.length || items.some((item) => !item.id)) {
      showError(container, 'One or more products in the bundle are unavailable.');
      return;
    }

    button.dataset.cartRedirectBusy = 'true';
    button.classList.add('bndlr-loading');

    try {
      const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
      const response = await fetch(cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || result.message || 'The bundle could not be added to the cart.');
      }

      document.cookie = 'bndlr_hide_discount_message=hide; max-age=300; path=/; SameSite=Lax';
      window.location.assign(window.routes?.cart_url || '/cart');
    } catch (error) {
      showError(container, error.message || 'The bundle could not be added to the cart.');
      button.classList.remove('bndlr-loading');
      delete button.dataset.cartRedirectBusy;
    }
  };

  const handleActivation = (event) => {
    const button = event.target.closest?.(buttonSelector);

    if (!button || button.dataset.active === 'false') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addBundleToCart(button);
  };

  document.addEventListener('click', handleActivation, true);
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Enter' || event.key === ' ') handleActivation(event);
    },
    true,
  );
})();
